app.controller("RoomsByTimeController", [
    "$scope", "TimetableService", "$stateParams", "StaticData", "$state", "usSpinnerService", "$uibModal",
    function ($scope, TimetableService, $stateParams, StaticData, $state, usSpinnerService, $uibModal) {
        var h = new Date().getHours();
        $scope.sessionStartTime = $stateParams.startTime || new Date(2018, 11, 31, h, 0);
        $scope.dayOfWeek = $stateParams.dayOfWeek || new Date().getDay();

        StaticData.getItemsByKey("days").then(function (days) {
            $scope.days = days;
            $scope.daysMap = _.keyBy($scope.days, '_id');
            $scope.sessionDayOfWeek = $scope.daysMap[$scope.dayOfWeek];
        });

        StaticData.getItemsByKey("buildings").then(function (buildings) {
            $scope.buildings = [{name: "კორპუსი"}].concat(buildings);
            $scope.buildingsMap = _.keyBy($scope.buildings, '_id');
        });

        StaticData.getItemsByKey("session_types").then(function (types) {
            $scope.sessionTypes = [{name: "სესიის ტიპი"}].concat(types);
            $scope.sessionTypesMap = _.keyBy($scope.sessionTypes, '_id');
        });

        loadPage($stateParams.dayOfWeek || $scope.dayOfWeek, $scope.sessionStartTime);

        $scope.applyFilter = function () {
            $state.go(".", {
                dayOfWeek : $scope.sessionDayOfWeek._id,
                startTime : $scope.sessionStartTime
            });
        };

        function loadPage(dayOfWeek, startTime, cb) {
            cb = cb || function () {
                };
            usSpinnerService.spin("root");
            TimetableService.dashboard({
                dayOfWeek : dayOfWeek,
                startTime : startTime
            }).then(function (data) {
                $scope.buildingsData = data;
                $scope.buildKeys = _.keys(data);
                usSpinnerService.stop("root");
                $scope.keys = _.keys($scope.buildingsData);
                cb();
            });
        };

        $scope.export = function () {
            TimetableService.exportList()
        };

        $scope.setSession = function (room) {
            $uibModal.open({
                controller: "DefineInTableController",
                templateUrl: _pb + 'admin/manage/defile-in-table.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {room: room, day: $scope.sessionDayOfWeek._id, startTime: new Date($scope.sessionStartTime).getHours()};
                    }
                }
            }).result
                .then(function () {
                    loadPage($stateParams.dayOfWeek || $scope.dayOfWeek, $stateParams.startTime || $scope.sessionStartTime);
                });
        };
    }
]);
